<!--  -->
<template>
  <div class="information">
    <h4 class="centerh4">学者信息</h4>
    <p class="tips mt20 mb20">* 以下信息将作为您认领学者所展示的信息</p>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="姓名：" prop="name">
        <el-input v-model="ruleForm.name" placeholder="请输入真实姓名"></el-input>
      </el-form-item>
      <el-form-item label="性别：" prop="sex">
        <el-radio-group v-model="ruleForm.sex">
          <el-radio label="男"></el-radio>
          <el-radio label="女"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="生日：" prop="date2">
        <el-date-picker v-model="ruleForm.date2" type="date" placeholder="选择日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="单位：" prop="company">
        <el-input placeholder="请填写您当前所在的单位" v-model="ruleForm.company"></el-input>
      </el-form-item>
      <el-form-item label="照片：" prop="imageUrl">
        <el-input style="display:none" v-model="ruleForm.imageUrl"/>
        <el-upload
          class="avatar-uploader"
          action="https://jsonplaceholder.typicode.com/posts/"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
        >
          <img v-if="ruleForm.imageUrl" :src="ruleForm.imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <p class="tips">* 您认领的学者在榜单中显示的照片</p>
      </el-form-item>
      <el-form-item label="学科：" prop="type">
        <el-checkbox-group v-model="ruleForm.type">
          <el-checkbox label="哲学" name="type"></el-checkbox>
          <el-checkbox label="法学" name="type"></el-checkbox>
          <el-checkbox label="经济学" name="type"></el-checkbox>
          <el-checkbox label="教育学" name="type"></el-checkbox>
          <el-checkbox label="文学" name="type"></el-checkbox>
          <el-checkbox label="历史学" name="type"></el-checkbox>
          <el-checkbox label="管理学" name="type"></el-checkbox>
          <el-checkbox label="艺术学" name="type"></el-checkbox>
        </el-checkbox-group>
        <p class="tips">* 请选择您主要涉及的学科门类，存在跨学科可多选</p>
      </el-form-item>
      <el-form-item label="简介：" prop="desc">
        <el-input type="textarea" placeholder="请输入衡量标准" v-model="ruleForm.desc"></el-input>
        <p class="tips mt5">* 该简介会显示在您所认领学者的主页上</p>
      </el-form-item>
      <el-form-item style="text-align:right">
        <el-button class="infobtn" type="primary" @click="submitForm('ruleForm')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      ruleForm: {
        name: "",
        company: "",
        sex: "",
        date2: "",
        type: [],
        desc: "",
        imageUrl: ""
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        company: [{ required: true, message: "请输入单位", trigger: "blur" }],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change"
          }
        ],
        imageUrl: [{ required: true, message: "请上传图片", trigger: "change" }]
      }
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.ruleForm);
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.imageUrl = URL.createObjectURL(file.raw);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let ruleForm1 = {
      name: "jzp",
      company: "111",
      sex: "nan",
      date2: "2018-10-24",
      type: ["教育学"],
      desc: "111111",
      imageUrl: ""
    };
    this.ruleForm = ruleForm1;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.mt5 {
  margin-top: 5px;
}
.mt20 {
  margin-top: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
.centerh4 {
  font-size: 16px;
  font-weight: 700;
  color: rgba(68, 68, 68, 1);
  line-height: 22px;
}
.information .tips {
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.information input {
  width: 350px;
}
.information textarea {
  height: 100px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.information .el-form-item__label {
  width: 54px !important;
  padding: 0;
}
.information .el-form-item__content {
  margin-left: 54px !important;
}
.information .infobtn {
  width: 100px;
  height: 35px;
  line-height: 35px;
  padding: 0;
  background: rgba(66, 103, 178, 1);
  border-color: rgba(66, 103, 178, 1);
  border-radius: 4px;
}
.information .infobtn:hover {
  background: #409EFF;
  border-color:#409EFF;
}
</style>


// WEBPACK FOOTER //
// src/view/personalCenter/information.vue